import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import { InputFeedback } from './Common';
import {Field} from 'formik';
import moment from 'moment';
import ApplicationHelpers from '../ApplicationHelpers';

export default class InputDateFormat extends Component {
    constructor(props) {
        super(props);
        this.dateFormat= this.dateFormat.bind(this);
        this.isDateValid = this.isDateValid.bind(this);
        //props
        this.format = this.props.format || 'MM/DD/YYYY';
        this.defaultValue = this.props.defaultvalue || '';
        //this should be before other props
        this.disableDay = ApplicationHelpers.formatStrictBoolean(this.props.disableday) || false;
        if(this.disableDay){
            this.format = 'MM/YYYY';
        }
        this.maxDate = moment(this.props.maxdate || new Date(2099,11,31), this.format);
        this.minDate = moment(this.props.mindate || new Date(1900,0,1),this.format);
    }
    valueFormat(val){ //only called for the very first time
        if(!val || typeof val !== "string")
            return val;
        if(this.disableDay){
            return val;
        }
        let d = moment(val);
        d = d.format(this.format);
        return d;
    }
    limit(val, max) {
        if (val.length === 1 && val[0] > max[0]) {
          val = '0' + val;
        }
       
        if (val.length === 2) {
          if (Number(val) === 0) {
            val = '01';
       
          //this can happen when user paste number
        } else if (val > max) {
            val = max;
          }
        }
        return val;
      }
    
    dateFormat(val) {
        if(!val){
            return '';
        }
        val = val.toString();
        let month = this.limit(val.substring(0, 2), '12');
        let day ='', year ='', finalVal='';
        if(this.disableDay){
            year = val.substring(2, 6); 
            finalVal = month + (year.length ? '/' + year : '');
        }
        else{
            day = this.limit(val.substring(2, 4), '31');
            year = this.limit(val.substring(4, 8), '2099');
            finalVal = month + (day.length ? '/'+day:'') + (year.length ? '/' + year : '');
        }
        finalVal = this.isDateValid(finalVal);
        return finalVal;
      }
      isDateValid(date){
          if(!date)
            return '';
          if(date.length >= 10 || (this.disableDay && date.length >= 7)){
              let d = moment(date,this.format);
              if(!d.isValid()){
                return '';
              }
              else if(d.isAfter(this.maxDate)){
                  return this.maxDate.format(this.format)
              }
              else if(d.isBefore(this.minDate)){
                  return this.minDate.format(this.format)
              }
              else{
                  return d.format(this.format)
              }
          }
          else{
              return date;
          }
      }
  render() {
    const { error } = this.props;
    return (
      <div>
        <Field
        component={NumberFormat}
        format={this.dateFormat}
        className={"form-control"}
        allowNegative={this.props.allowNegative || false}
        {...this.props}
        value={this.valueFormat(this.props.inputvalue)}
        />
        {<InputFeedback error={error} />}
      </div>
    );
  }
}